export default function () {
  return {
    // 基本信息
    baseInfoList: [
      {
        name: '司机姓名',
        key: 'customerName',
      },
      {
        name: '手机号',
        key: 'customerTel',
      },
      {
        name: '车牌号',
        key: 'plateNo',
      },
      {
        name: '合作模式',
        key: 'rentCategory',
      },
      {
        name: '订单ID',
        key: 'orderId',
      },
      {
        name: '订单状态',
        key: 'orderState',
      },
      {
        name: '收款起止日期',
        key: 'orderPeriod',
      },
    ],
    // 预警信息
    warnInfoList: [
      {
        name: '预警类型',
        key: 'warnLevel',
      },
      {
        name: '预警状态',
        key: 'warnState',
      },
      {
        name: '预警开始时间',
        key: 'startTime',
      },
      {
        name: '预警更新时间',
        key: 'modifyTime',
      },
      {
        name: '预警结束时间',
        key: 'endTime',
      },
      {
        name: '预警时长',
        key: 'warnDuration',
      },
      {
        name: '预警详情',
        key: 'warnDetails',
        alone: true,
      },
      {
        name: '已占押金比例',
        key: 'amountRatio',
        alone: true,
      },
    ],
    // 风险信息
    riskInfoList: [
      {
        name: '风险欠款合计',
        key: 'totalDebt',
      },
      {
        name: '未处理违章罚款',
        key: 'pendingViolateAmount',
      },
      {
        name: '未处理违章分数',
        key: 'pendingViolateScore',
      },
      {
        name: '往期欠款',
        key: 'pastDebt',
      },
      {
        name: '当前周期租金欠款',
        key: 'currentDebt',
      },
    ],
    riskInfoSubList: [
      {
        name: '待退款金额总计',
        key: 'receivedDeposit',
      },
      {
        name: '租金退款',
        key: 'rentReturnAmount',
      },
      {
        name: '押金退款',
        key: 'depositReturnAmount',
      },
    ],
    // 预警变更记录
    recordColumn: [
      // {
      //   name: 'id',
      //   columnProps: {
      //     prop: 'id',
      //     label: '变更内容'
      //   }
      // },
      {
        name: 'modifyLevelInfo',
        columnProps: {
          prop: 'modifyLevelInfo',
          label: '变更等级信息',
        },
        showEllipsisTooltip: true,
        limitEllipsisLine: 1,
      },
      {
        name: 'modifyReason',
        columnProps: {
          prop: 'modifyReason',
          label: '变更原因',
        },
        showEllipsisTooltip: true,
        limitEllipsisLine: 1,
      },
      {
        name: 'modifyTime',
        columnProps: {
          prop: 'modifyTime',
          label: '变更时间',
        },
      },
    ],
  }
}
